//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ethers, utils, Wallet } from "ethers";
import { mapGetters, mapMutations } from "vuex";
import AWalletHelpers from "@/assets/js/AWalletHelpers";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "../AQInput/AQInput.vue";
import AQUploader from "../AQUploader/AQUploader.vue";
import AWalletAccount from "./AWalletAccount.vue";

export default {
    components: {
        AWalletAccount,
        AQUploader,
        AQInput,
        AQButton
    },
    props: {
        embedded: {
            type: Boolean,
            default: false
        },
        selectChanged: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        stopDecrypting: {
            type: Boolean,
            default: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            type: "",
            keystorePassword: "",
            loadingKeystore: false,
            passphrase: "",
            seedphrase: "",
            privateKey: "",
            keystoreFile: null,
            walletInitialised: false,
            saveMethod: "local",
            accounts: [],
            errors: {
                mnemonic: {
                    active: false,
                    text: this.$t("wallet.error.invalidMnemonic")
                },
                privateKey: {
                    active: false,
                    text: this.$t("wallet.error.invalidPrivateKey")
                },
                keystorePassword: {
                    active: false,
                    text: this.$t("wallet.error.invalidPassword")
                }
            },
            model: {
                name: "Wallet 1",
                password: "",
                confirmPassword: ""
            },
            uploadError: "",
            decryptedWallet: null
        };
    },
    computed: {
        ...mapGetters({
            getSaveForLater: "aWallet/getSaveForLater"
        }),
        areFieldsValid() {
            return this.model.name;
        }

    },
    watch: {
        type() {
            this.walletInitialised = false;
        },
        selectChanged(newValue) {
            if (newValue || newValue === 0) {
                this.type = "";
            }
        }
    },
    mounted() {
        this.$root.$on("wallet-import", () => {
            this.importWallet();
        });
    },
    destroyed() {
        this.$root.$off("wallet-import");
    },
    methods: {
        ...mapMutations({
            setCtaDisabled: "aWallet/setCtaDisabled"
        }),
        changeMethod(val) {
            this.saveMethod = val;
        },
        optionChanged() {
            this.setCtaDisabled(true);
            this.cleanPassField(this.type);
            this.$emit(
                "selectRadio"
            );
        },
        cleanPassField(type) {
            if (type === "hd" && (this.seedphrase || this.passphrase)) {
                this.seedphrase = null;
                this.passphrase = null;
                this.errors.mnemonic.active = false;
            } else if (type === "privateKey" && this.privateKey) {
                this.privateKey = null;
                this.errors.privateKey.active = false;
            } else if (type === "keystoreFile" && (this.keystorePassword || this.keystoreFile)) {
                this.keystorePassword = null;
                this.keystoreFile = null;
                this.errors.keystorePassword.active = false;
            }
        },
        async importWallet() {
            if (this.type && this.$refs["wallet-account"].checkForErrors()) {
                return;
            }
            let dataToEncrypt;
            let keystore;

            if (this.type === "hd") {
                dataToEncrypt = this.seedphrase;
            }

            if (this.type === "privateKey") {
                dataToEncrypt = this.privateKey;
            }

            if (this.type === "keystoreFile") {
                keystore = await this.keystoreFile.text();
            }

            try {
                const accounts = [];
                this.accounts.map((account, index) => (
                    accounts.push({
                        name: `Account ${index + 1}`,
                        address: account.address
                    })
                ));
                await AWalletHelpers.saveWallet(this.model.name, dataToEncrypt, this.model.password,
                    this.type, accounts, keystore, this.passphrase, this.saveMethod);
                this.$toast.showNotify({
                    message: this.$t("wallet.importSuccess"),
                    type: "success"
                });
                this.$emit("action", "close");
                this.$emit("refresh-wallet-list");
                this.$emit("import-success", this.decryptedWallet);
            } catch (e) {
                this.$toast.showNotify({
                    message: this.$t("wallet.error.unknownError"),
                    type: "error"
                });
            }
        },
        async initializeWallet(type) {
            this.$emit("disabledWallet", true);
            this.accounts = [];
            AWalletHelpers.getAllWallets().then(data => {
                // check if current names contains copy numbering EX: Wallet 1
                let walletName = "";
                let numberToReturn = 0;
                data.forEach(curr => {
                    const number = parseInt(curr.name.match(/((\d+))/), 10);
                    // eslint-disable-next-line
                    if (!isNaN(number)) {
                        if (parseInt(number, 10) > numberToReturn) {
                            numberToReturn = parseInt(number, 10);
                        }
                    }
                    // generate unique wallet names based on the existing one
                    walletName = `${this.$t("wallet.importOptions.wallet")} ${numberToReturn + 1}`;
                    this.model.name = walletName;
                });
            });
            if (type === "hd") {
                try {
                    const hdNode = utils.HDNode.fromMnemonic(this.seedphrase, this.passphrase)
                        .derivePath("m/44'/60'/0'/0/0");
                    const wallet = new Wallet(hdNode.privateKey);
                    this.decryptedWallet = { ...wallet };
                    this.decryptedWallet.privateKey = wallet.privateKey;
                    this.accounts.push(wallet);
                    this.walletInitialised = true;
                    this.setCtaDisabled(false);
                } catch (e) {
                    this.errors.mnemonic.active = true;
                }
            } else if (type === "privateKey") {
                try {
                    const wallet = new ethers.Wallet(this.privateKey);
                    this.decryptedWallet = { ...wallet };
                    this.decryptedWallet.privateKey = wallet.privateKey;
                    this.accounts.push(wallet);
                    this.walletInitialised = true;
                    this.setCtaDisabled(false);
                } catch (e) {
                    this.errors.privateKey.active = true;
                }
            } else if (type === "keystoreFile") {
                this.loadingKeystore = true;
                this.$emit("loadingKeystore", this.loadingKeystore);
                try {
                    const json = await this.keystoreFile.text();
                    const wallet = await ethers.Wallet.fromEncryptedJson(json, this.keystorePassword);
                    if (this.stopDecrypting) {
                        this.decryptedWallet = { ...wallet };
                        this.decryptedWallet.privateKey = wallet.privateKey;
                        this.accounts.push(wallet);
                        this.walletInitialised = true;
                        this.setCtaDisabled(false);
                    }
                } catch (e) {
                    if (e.message === "invalid password") {
                        this.errors.keystorePassword.active = true;
                    } else {
                        this.uploadError = this.$t("wallet.error.invalidKeystore");
                    }
                } finally {
                    this.loadingKeystore = false;
                }
            }
            this.$emit("disabledWallet", false);
        },
        parseKeystoreFile(event) {
            this.keystoreFile = event[0].file;
            this.uploadError = "";
        },
        generateAccount() {
            const path = `m/44'/60'/0'/0/${this.accounts.length}`;
            const hdNode = ethers.utils.HDNode.fromMnemonic(this.seedphrase, this.passphrase)
                .derivePath(path);
            const wallet = new Wallet(hdNode.privateKey);

            this.accounts.push(wallet);
        },
        changeKeystore() {
            this.walletInitialised = false;
            this.keystoreFile = null;
            this.setCtaDisabled(true);
        },
        initializeAnother() {
            this.walletInitialised = false;
            this.setCtaDisabled(true);
        }
    }
};
